import { createSelector } from 'reselect'

export const getIsTransitioning = createSelector(
  state => Boolean(state && state.common && state.common.transitions && state.common.transitions.isTransitioning),
  isLoading => isLoading
)
